webpackJsonp([76],{

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1278);


/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(179);

var _datetime2 = _interopRequireDefault(_datetime);

var _fr = __webpack_require__(794);

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('fr', _fr2.default);

/***/ })

},[1277]);


// WEBPACK FOOTER //
// app/datetime.fr-884fccc23c5c1e1f1cbe.js